module.exports = __webpack_public_path__ + "img/1-04.69e6f472.jpg";